import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { object, number } from "prop-types";
import { Row, Col } from "react-bootstrap";
import ColoredRawScoreScale from "components/DynamicScoreReportScales/ColoredRawScoreScale";
import { correctColumnFormatter } from "./CandidateResponseReports/candidateResponseHelpers";

const CLIK = ({ testId, testScores }) => {
  const getOverview = () => (
    <Row className="gray-bottom-border">
      <Col>
        <h3 className="reportHeader mt-3 mb-4">Overview</h3>
        <Row>
          <ColoredRawScoreScale
            score={testScores ? testScores.get("rawScore") : 0}
            testId={testId}
          />
        </Row>
      </Col>
    </Row>
  );

  const getCandidateResponse = () => (
    <Row>
      <Col>
        <h3 className="reportHeader my-3">Candidate Responses</h3>
        <Row>{getSimulationTables()}</Row>
        <Row>{getQuestionTable()}</Row>
      </Col>
    </Row>
  );

  const getSimulationTables = () => {
    const simulations = testScores && testScores.get("simulations");
    if (!simulations) {
      return null;
    }
    const columns = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "correct",
        text: "Correct?",
        headerClasses: "text-center",
        classes: "text-center",
        formatter: correctColumnFormatter,
      },
    ];

    const simulationTablesArray = [];
    let currentSimulationData = [];
    simulations.forEach((simulation, idx) => {
      currentSimulationData.push({
        id: simulation.get("skillId"),
        correct: simulation.get("isCorrect"),
        simulationText: simulation.get("skillName"),
      });

      // We only push the table to the array on every 5th simulation, or if it is the last simulation.
      const index = idx + 1;
      if (index % 5 !== 0 && simulations.size !== index) {
        return;
      }

      const simulationTableNumber = simulationTablesArray.length + 1;

      const currentColumns = [...columns];
      currentColumns.push({
        dataField: "simulationText",
        text: `Simulation ${simulationTableNumber} (Total time taken: ${simulation.get(
          "timeSpent"
        )} seconds)`,
      });

      simulationTablesArray.push(
        <div
          key={simulationTableNumber}
          className="mr-4"
          style={{ width: "500px" }}
        >
          <BootstrapTable
            keyField="id"
            data={currentSimulationData}
            columns={currentColumns}
            bordered={false}
          />
        </div>
      );

      currentSimulationData = [];
    });

    return simulationTablesArray;
  };

  const getQuestionTable = () => {
    const questions = testScores && testScores.get("questions");
    if (!questions) {
      return null;
    }
    const columns = [
      {
        dataField: "id",
        text: "#",
      },
      {
        dataField: "correct",
        text: "Correct?",
        headerClasses: "text-center",
        classes: "text-center",
        formatter: correctColumnFormatter,
      },
      {
        dataField: "questionText",
        text: "Question",
      },
      {
        dataField: "timeTaken",
        text: "Time Taken",
        headerClasses: "sticky-element",
      },
    ];
    const data = [];
    testScores.get("questions").forEach((question, i) => {
      data.push({
        correct: question.get("isCorrect"),
        questionText: question.get("questionStem"),
        timeTaken: `${question.get("timeTaken")} sec`,
        id: `${i + 1}`,
      });
    });

    return (
      <div className="w-100">
        <BootstrapTable
          keyField="id"
          data={data}
          columns={columns}
          bordered={false}
        />
      </div>
    );
  };

  return (
    <Col>
      {getOverview()}
      {getCandidateResponse()}
    </Col>
  );
};

CLIK.propTypes = {
  testScores: object,
  testId: number,
};

export default CLIK;
